// https://stackoverflow.com/a/15724300
export const getCookie = (name) => {
  const value = `; ${ document.cookie}`;
  const parts = value.split(`; ${ name }=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
};
